let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1CqOv")).then(() => parcelRequire('22IYd'));